import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";

export const CONSENT_KEY = "eid_cookie_consent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let t;
    try {
      if (!localStorage.getItem(CONSENT_KEY)) t = setTimeout(() => setShow(true), 1600);
    } catch {
      setShow(true);
    }
    return () => clearTimeout(t);
  }, []);

  const choose = (value) => {
    try {
      localStorage.setItem(CONSENT_KEY, value);
    } catch {}
    window.dispatchEvent(new Event("eid-consent-changed"));
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-24 left-4 right-4 z-[65] sm:left-6 sm:right-auto sm:max-w-md"
          data-testid="cookie-banner"
        >
          <div className="rounded-2xl border border-gold/30 bg-navy-deep/95 p-6 shadow-2xl shadow-black/40 backdrop-blur-xl">
            <div className="flex items-start gap-4">
              <Cookie className="mt-1 h-5 w-5 shrink-0 text-gold" />
              <div>
                <p className="font-serif text-lg text-ivory">A word on cookies</p>
                <p className="mt-2 text-xs font-light leading-relaxed text-slate-400">
                  We use Google Analytics cookies to understand which pages help visitors most. Nothing is tracked
                  unless you accept. Read our{" "}
                  <Link to="/privacy" className="text-gold-glow underline underline-offset-2">privacy notice</Link>.
                </p>
                <div className="mt-4 flex gap-3">
                  <button
                    onClick={() => choose("accepted")}
                    data-testid="cookie-accept-btn"
                    className="rounded-full bg-gold px-5 py-2 text-xs font-semibold text-navy-deep transition-colors duration-300 hover:bg-gold-light"
                  >
                    Accept
                  </button>
                  <button
                    onClick={() => choose("declined")}
                    data-testid="cookie-decline-btn"
                    className="rounded-full border border-gold/30 px-5 py-2 text-xs font-medium text-slate-300 transition-colors duration-300 hover:border-gold/60 hover:text-ivory"
                  >
                    Decline
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
